import(/* webpackMode: "eager" */ "/vercel/path0/apps/magicsky/src/app/(public)/login/page.tsx");
